import WillBeTerminated from './WillBeTerminated';

export default WillBeTerminated;